import { LoadSampleData } from './tutorials/LoadSampleData';
import { WelcomeTourTutorial } from './tutorials/WelcomeTourTutorial.jsx';
import { ReconstructingTutorial } from './tutorials/ReconstructingTutorial.jsx';
import { PreprocessingTutorial } from './tutorials/PreprocessingTutorial.jsx';


const tutorials = [
  WelcomeTourTutorial({prefix: 'Tutorial 1: '}),
  PreprocessingTutorial({prefix: 'Tutorial 2: '}),
  ReconstructingTutorial({prefix: 'Tutorial 3: '}),
]


const TutorialCard = ({title, section, description, img, videoUrl}) => (
  <div className="col">
    <div className="card h-100">
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <img src={img} className="card-img-top" alt="Representative image for tutorial" />
        <p className="card-text">
          {description}
        </p>
        <div className="btn-group">
          <a href={'#'+section} role="button" style={{color: "white", textDecoration: "none"}} className="btn btn-primary">
            <i className="bi bi-book-fill"></i> Read
          </a>
          {
            videoUrl ?
              <a href={videoUrl} role="button" style={{color: "white", textDecoration: "none"}} className="btn btn-danger">
                <i className="bi bi-youtube"></i> Watch
              </a> :
              <></>
          }
        </div>
      </div>
    </div>
  </div>
)


export const TutorialPage = ({setToken}) => (
  <div className="doc-container">
    <h2>Tutorials</h2>
    <div className="row row-cols-1 row-cols-md-3 g-4">
      { tutorials.map(({title, section, description, img, videoUrl}, i) => (
        <TutorialCard title={title} section={section} description={description} img={img} number={i+1} videoUrl={videoUrl}/>
      ))}
    </div>
    {tutorials.map(({section, tutorial}) => (
      <section id={section}>
        {tutorial({setToken})}
      </section>
    ))}
    <LoadSampleData setToken={setToken}/>
  </div>
)
